export default {"src":"/_next/static/media/img_linkedin_4_1.39581bcb.svg","height":1160,"width":720,"blurWidth":0,"blurHeight":0};